// 校验cron表达式
function isValidCronExpression(cronExpression) {
  const fields = cronExpression.split(" ")
  if (fields.length < 5 || fields.length > 6) {
    return false // Cron表达式必须有5或6个字段
  }

  const cronRegex = /^(?:(?:\*|\?|\d{1,2}(?:-\d{1,2})?(?:,\d{1,2}(?:-\d{1,2})?)*|\d{1,2}\/\d{1,2}|L(?:-\d{1,2})?|LW|W|\d{1,2}W|\d{1,2}#\d{1,2}) ){5}(?:(?:\*|\?|\d{1,2}(?:-\d{1,2})?(?:,\d{1,2}(?:-\d{1,2})?)*|\d{1,2}\/\d{1,2}|L(?:-\d{1,2})?|LW|W|\d{1,2}W|\d{1,2}#\d{1,2})|(?:\*|\?|\d{1,2}(?:-\d{1,2})?(?:,\d{1,2}(?:-\d{1,2})?)*|\d{1,2}\/\d{1,2}|L(?:-\d{1,2})?|LW|W|\d{1,2}W|\d{1,2}#\d{1,2}))$/
  const flag = cronRegex.test(cronExpression)
  if (!flag) { return false }

  let s, min, h, day, month, week
  // 再校验每个字段的范围
  if (fields.length === 5) {
    [min, h, day, month, week] = fields
  } else if (fields.length === 6) {
    [s, min, h, day, month, week] = fields
  }

  // 校验秒字段
  if (s !== undefined) {
    if (!validateField(s, 0, 59)) {
      return false
    }
  }

  // 校验分钟字段
  if (!validateField(min, 0, 59)) {
    return false
  }

  // 校验小时字段
  if (!validateField(h, 0, 23)) {
    return false
  }

  // 校验日期字段
  if (!validateField(day, 1, 31)) {
    return false
  }

  // 校验月份字段
  if (!validateField(month, 1, 12)) {
    return false
  }

  // 校验星期字段
  if (!validateField(week, 0, 7)) {
    return false
  }

  return true
}

function validateField(field, min, max) {
  const parts = field.split(",")
  for (const part of parts) {
    if (part.includes("-")) {
      const [start, end] = part.split("-").map(Number)
      if (start < min || end > max || start > end) {
        return false
      }
    } else if (part.includes("/")) {
      const [base, step] = part.split("/").map(Number)
      if (base < min || base > max || step <= 0) {
        return false
      }
    } else if (part === "*" || part === "?") {
      continue
    } else {
      const value = Number(part)
      if (value < min || value > max) {
        return false
      }
    }
  }
  return true
}

export default isValidCronExpression